import { getCosmicLocalizationCurrency } from '@taxbit-private/cosmic-localization'

import { Transaction } from 'api/types/transaction/transactionApiTypes'

export function getBaseFiatValue(txn?: Transaction) {
  const currency = getCosmicLocalizationCurrency()
  return txn?.value.convertedValues.find((v) => v.asset === currency)?.amount || 0
}

export function getBaseFiatCost(txn?: Transaction) {
  const currency = getCosmicLocalizationCurrency()
  return txn?.value.convertedCosts.find((v) => v.asset === currency)?.amount || 0
}
